import PropTypes from 'prop-types';
import React from 'react';
import Link from '../Link';

const style = {
  width: '100%',
  padding: '30px 0',
};

const imgStyle = {
  width: '260px',
  height: 'auto',
};

const Logo = ({ imgSrc, url }) => (
  <div style={style}>
    <Link href={url}>
      <img src={imgSrc} alt="VU.CITY Logo" style={imgStyle} />
    </Link>
  </div>
);

Logo.propTypes = {
  imgSrc: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default Logo;
